// extracted by mini-css-extract-plugin
export default {"languagesList":"Languages_languagesList__Wgdrk","languagesItem":"Languages_languagesItem__wllB2","progressBar":"Languages_progressBar__I3J6p","progress":"Languages_progress__14y3y"};